import versionsCache from '@atlassian/jira-cache/src/services/versions/index.tsx';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type { VersionId } from '../../../common/model/index.tsx';
import type { FieldOperation } from '../../model/types.tsx';
import { deleteAndSwapVersion as deleteAndSwapVersionRest } from '../../rest/delete/index.tsx';
import { transformSwapConfiguration } from './transformers.tsx';

export const deleteAndSwapVersion = (
	id: VersionId,
	swapConfiguration: FieldOperation[],
): Promise<void> =>
	deleteAndSwapVersionRest(id, transformSwapConfiguration(swapConfiguration)).then((result) => {
		try {
			id && versionsCache.remove(id);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			log.safeErrorWithoutCustomerData('project-directories.versions.cache.remove', error.message);
		}
		return result;
	});
